import { MiniApplicationManifest } from './core/helpers/dna';
import { DesignerAPI } from '@brg/api';

/**
 * Делегат движка
 */
export class BurgundyEngineDelegate {
    /**
     * Возвращает промис для получения данных профиля внутри проекта
     * @param associatedIdentifier
     */
    public static shouldGetProfileInformationFrom(associatedIdentifier: string) {
        return DesignerAPI.Get({ idDesigner: associatedIdentifier });
    }

    /**
     * Возвращает true, если необходим запуск приложения авторизации
     * @param url
     */
    public static shouldUseAuthenticationApplication(url: Location): boolean {
        return (
            url.pathname.startsWith('/login/') ||
            url.pathname.startsWith('/silent/') ||
            url.pathname.startsWith('/access') ||
            url.pathname.startsWith('/logout/') ||
            url.pathname.startsWith('/stats')
        );
    }

    /**
     * Запускает экстро-приложение по собственным правилам проекта
     */
    public static shouldRunExtraApplication(location: Location): boolean | string {
        // if (location.pathname.startsWith('/competition')) return 'competition';
        const hash = location.hash?.match(/#!([a-z]+)/)?.pop();
        if (hash) return hash;

        return false;
    }

    /**
     * Возвращает true, если необходим запрос для BGID
     * @param manifest
     */
    public static shouldUseBGIDRequest(manifest: MiniApplicationManifest): boolean {
        return false;
    }
}
import { MiniApplicationManifest } from './core/helpers/dna';
import { DesignerAPI } from '@brg/api';

/**
 * Делегат движка
 */
export class BurgundyEngineDelegate {
    /**
     * Возвращает промис для получения данных профиля внутри проекта
     * @param associatedIdentifier
     */
    public static shouldGetProfileInformationFrom(associatedIdentifier: string) {
        return DesignerAPI.Get({ idDesigner: associatedIdentifier });
    }

    /**
     * Возвращает true, если необходим запуск приложения авторизации
     * @param url
     */
    public static shouldUseAuthenticationApplication(url: Location): boolean {
        return (
            url.pathname.startsWith('/login/') ||
            url.pathname.startsWith('/silent/') ||
            url.pathname.startsWith('/access') ||
            url.pathname.startsWith('/logout/') ||
            url.pathname.startsWith('/stats')
        );
    }

    /**
     * Запускает экстро-приложение по собственным правилам проекта
     */
    public static shouldRunExtraApplication(location: Location): boolean | string {
        // if (location.pathname.startsWith('/competition')) return 'competition';
        const hash = location.hash?.match(/#!([a-z]+)/)?.pop();
        if (hash) return hash;

        return false;
    }

    /**
     * Возвращает true, если необходим запрос для BGID
     * @param manifest
     */
    public static shouldUseBGIDRequest(manifest: MiniApplicationManifest): boolean {
        return false;
    }
}
